





















































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import DokterAutoComplete from "@/components/pemeriksaan/assesmen/DokterAutoComplete.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { storeCeklistAlteplase } from "@/store/modules/CeklistAlteplaseStore";
import CeklistAlteplaseSvc from "@/services/CeklistAlteplase";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { localISODate } from "@/utils/localDate";

@Component({
  components: {
    DokterAutoComplete,
    VCDateTimePicker
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CeklistAlteplasePage extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  isEditing = false;
  editingId: number | null = null;
  saving = false;
  formValid = false;

  form: any = this.getEmptyForm();

  mounted() {
    storeCeklistAlteplase.loadMasters();
    storeCeklistAlteplase.getByRegister(this.register);
  }

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get stateData() {
    return storeCeklistAlteplase.data;
  }

  get stateLoading() {
    return storeCeklistAlteplase.loading;
  }

  get stateuser() {
    return userModule.user;
  }

  get indikasiItems() {
    return storeCeklistAlteplase.indikasiItems;
  }

  get kontraItems() {
    return storeCeklistAlteplase.kontraItems;
  }

  get masterSiap() {
    return this.indikasiItems.length > 0 && this.kontraItems.length > 0;
  }

  get canEdit() {
    return !this.readOnly && !!this.stateData && this.masterSiap;
  }

  get canDelete() {
    if (this.readOnly || !this.stateData) return false;
    return this.stateData.creator_user_id == this.stateuser.id;
  }

  get semuaIndikasiOk() {
    return this.indikasiItems.every(i => this.form[i.key] === true);
  }

  get adaKontra() {
    return this.kontraItems.some(i => this.form[i.key] === true);
  }

  get computedKesimpulan() {
    return this.adaKontra ? "tidak_dapat_diberikan" : "dapat_diberikan";
  }

  get tanggalDate(): Date | null {
    return this.form.tanggal ? this.strToDate(this.form.tanggal) : null;
  }

  set tanggalDate(val: Date | null) {
    this.form.tanggal = val ? localISODate(val) : null;
  }

  strToDate(val: string): Date {
    const parts = String(val).slice(0, 10).split("-");
    return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
  }

  formatDate(val) {
    if (!val) return "-";
    const d = this.strToDate(val);
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}`;
  }

  ketOf(data, key) {
    if (!data || !data.keterangan) return "";
    return data.keterangan[key] || "";
  }

  getEmptyForm() {
    const form: any = {
      tanggal: localISODate(new Date()),
      nihss_score: null,
      keterangan: {},
      catatan_kesimpulan: null,
      dokter_user_id: null,
      dokter_obj: null
    };

    for (const item of storeCeklistAlteplase.indikasiItems) {
      form[item.key] = false;
    }

    for (const item of storeCeklistAlteplase.kontraItems) {
      form[item.key] = false;
      form.keterangan[item.key] = "";
    }

    return form;
  }

  setDokter(dokter) {
    if (dokter) {
      this.form.dokter_user_id = dokter.id;
      this.form.dokter_obj = dokter;
    }
  }

  startCreate() {
    this.form = this.getEmptyForm();

    if (this.stateuser && this.stateuser.profesi === "Dokter") {
      this.form.dokter_user_id = this.stateuser.id;
      this.form.dokter_obj = { id: this.stateuser.id, nama: this.stateuser.nama };
    }

    this.isEditing = true;
    this.editingId = null;
  }

  startEdit() {
    const d = this.stateData;
    const form = this.getEmptyForm();

    form.tanggal = d.tanggal ? String(d.tanggal).slice(0, 10) : form.tanggal;
    form.nihss_score = d.nihss_score;
    form.catatan_kesimpulan = d.catatan_kesimpulan;
    form.dokter_user_id = d.dokter_user_id;
    form.dokter_obj = d.dokter_user_id ? { id: d.dokter_user_id, nama: d.dokter_nama } : null;

    for (const item of this.indikasiItems) {
      form[item.key] = !!d[item.key];
    }

    for (const item of this.kontraItems) {
      form[item.key] = !!d[item.key];
      form.keterangan[item.key] = this.ketOf(d, item.key);
    }

    this.form = form;
    this.editingId = d.id;
    this.isEditing = true;
  }

  cancelForm() {
    this.isEditing = false;
    this.editingId = null;
    this.form = this.getEmptyForm();
  }

  buildPayload() {
    const payload: any = {
      register_id: this.register,
      pasien_rm: this.rm || this.$route?.params?.rm,
      tanggal: this.form.tanggal,
      nihss_score:
        this.form.nihss_score === "" || this.form.nihss_score === undefined
          ? null
          : this.form.nihss_score,
      keterangan: {},
      catatan_kesimpulan: this.form.catatan_kesimpulan || null,
      dokter_user_id: this.form.dokter_obj ? this.form.dokter_obj.id : this.form.dokter_user_id
    };

    for (const item of this.indikasiItems) {
      payload[item.key] = this.form[item.key] === true;
    }

    for (const item of this.kontraItems) {
      payload[item.key] = this.form[item.key] === true;
      const ket = (this.form.keterangan[item.key] || "").trim();
      if (ket) payload.keterangan[item.key] = ket;
    }

    return payload;
  }

  async simpan() {
    const ref = this.$refs.formRef as any;
    if (ref && !ref.validate()) return;

    if (!this.form.dokter_obj && !this.form.dokter_user_id) {
      appModule.NoticeDelay("Dokter pemeriksa wajib dipilih");
      return;
    }

    this.saving = true;

    try {
      const payload = this.buildPayload();

      const resp = this.editingId
        ? await CeklistAlteplaseSvc.update(this.editingId, payload)
        : await CeklistAlteplaseSvc.create(payload);

      if (resp.data.status == "1") {
        appModule.NoticeDelay("Ceklist Alteplase berhasil disimpan");
        this.cancelForm();
        storeCeklistAlteplase.getByRegister(this.register);
      }
    } finally {
      this.saving = false;
    }
  }

  cetakPdf() {
    CeklistAlteplaseSvc.print(this.stateData.id);
  }

  async remove() {
    const q = confirm("Anda yakin akan menghapus Ceklist Alteplase ini?");
    if (!q) return;

    try {
      const resp = await CeklistAlteplaseSvc.destroy(this.stateData.id);
      if (resp) {
        appModule.NoticeDelay("Berhasil menghapus data");
        storeCeklistAlteplase.getByRegister(this.register);
      }
    } catch {
      // ditangani service
    }
  }
}
